import styled from "styled-components"

// mainPage Wrapper
const MainWrapper = styled.main`
    padding: 20px;
    height: calc(100vh - 3rem - 40px);
`
export default MainWrapper